export default __webpack_public_path__ + "static/media/Imagem6.260c5d5b.png";